/*
 * @Descripttion:
 * @Author: hejiajun
 * @Date: 2026-02-09 16:31:18
 * @LastEditors: BILYHO 627008265@qq.com
 * @LastEditTime: 2026-02-11 22:51:03
 */
// APP_CONFIG 通过new webpack.DefinePlugin进行注入
import appConfigs from "./config/appConfig.js";
import registerApps from "./config/registerApps.js";
import { createImportMapScript } from "./config/utils.js";

// ==================== 常量定义 ====================
const MODULE_NAMES = {
  SINGLE_SPA: "single-spa",
  VUE: "vue",
  VUE_ROUTER: "vue-router",
  TDESIGN_VUE_NEXT: "tdesign-vue-next",
};

const REQUIRED_MODULES = [
  MODULE_NAMES.SINGLE_SPA,
  MODULE_NAMES.VUE,
  MODULE_NAMES.TDESIGN_VUE_NEXT,
];

// ==================== 全局变量初始化 ====================
// eslint-disable-next-line no-undef
const isLocal = APP_CONFIG?.isLocal ?? false;
// eslint-disable-next-line no-undef
const importmapConfig = __IMPORTMAP_CONFIG__;

window.isLocal = isLocal;

// ==================== 工具函数 ====================
/**
 * 处理 import-map-overrides 配置（仅本地环境）
 */
function handleImportMapOverrides() {
  if (!isLocal) return null;

  const overrideMap = window.importMapOverrides?.getOverrideMap();
  if (overrideMap?.imports) {
    Object.assign(importmapConfig.imports, overrideMap.imports);
  }
  return overrideMap;
}

/**
 * 打印调试信息
 */
function printDebugInfo(overrideMap) {
  console.group("应用配置调试");
  // eslint-disable-next-line no-undef
  console.log("当前环境:", APP_CONFIG);
  console.log("overrideMap:", overrideMap);
  console.log("引入文件:", importmapConfig);
  console.log("引入模块路径:", appConfigs);
  console.groupEnd();
}

/**
 * 验证 SystemJS 是否可用
 */
function validateSystemJS() {
  if (!window.System) {
    console.error("SystemJS 未加载成功");
    return false;
  }
  return true;
}

/**
 * 加载核心模块
 * @returns {Promise<Array>} 模块加载结果
 */
async function loadCoreModules() {
  const tasks = REQUIRED_MODULES.map((moduleName) =>
    window.System.import(moduleName),
  );
  const [singleSpa, Vue, TDesign] = await Promise.all(tasks);

  // vue-router.global.js (UMD) 执行时依赖 window.Vue，必须先挂载
  window.Vue = Vue;

  const vueRouter = await window.System.import(MODULE_NAMES.VUE_ROUTER);
  return [singleSpa, Vue, TDesign, vueRouter];
}

/**
 * 将模块挂载到 window 对象
 */
function exposeModulesToWindow(singleSpa, Vue, TDesign, vueRouter) {
  window.singleSpa = singleSpa;
  window.Vue = Vue;
  window.TDesign = TDesign;
  window.vueRouter = vueRouter;
}

// ==================== 主初始化函数 ====================
async function init() {
  // 0. 处理根路径重定向：访问 / 时重定向到 /blog

  if (window.location.pathname === "/") {
    window.history.replaceState(null, "", "/blog");
  }

  // 1. 处理 import-map-overrides 配置
  const overrideMap = handleImportMapOverrides();

  // 2. 创建 systemjs-importmap
  createImportMapScript("systemjs-importmap", importmapConfig);

  // 3. 打印调试信息
  printDebugInfo(overrideMap);

  // 4. 验证 SystemJS
  if (!validateSystemJS()) return;

  // 5. 加载核心模块
  try {
    const [singleSpa, Vue, TDesign, vueRouter] = await loadCoreModules();
    console.log("模块加载结果:", [singleSpa, Vue, TDesign, vueRouter]);

    // 6. 验证模块加载结果
    if (!singleSpa) {
      console.error("singleSpa 未加载成功");
      return;
    }

    // 7. 暴露模块到全局
    exposeModulesToWindow(singleSpa, Vue, TDesign, vueRouter);

    // 8. 注册应用并启动
    registerApps({
      singleSpa,
      System: window.System,
      appConfigs,
      isLocal,
      overrideMap,
    });
    singleSpa.start();
  } catch (error) {
    console.error("核心模块加载失败:", error);
  }
}

// ==================== 启动初始化 ====================
window.addEventListener("DOMContentLoaded", init);
